export default [
  {
    text: 'Title',
    value: 'title',
  },
  {
    text: 'Country',
    value: 'country.name',
    apiSort: 'country',
  },
  {
    text: 'Languages',
    value: 'languages',
    sortable: false,
    apiSort: 'predefined_comments_text.language',
  },
  {
    text: 'Actions',
    value: 'actions',
    action: 'delete',
    icon: 'delete',
    width: '160px',
    sortable: false,
  },
];
